// import React, { useState, useEffect, Suspense, lazy } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { setHeaderText } from "../../../features/headerText/headerTextSlice";
// import "./accountSetting.css";
// // Lazy-loaded components
// const OwnerDetails = lazy(() => import("../../../components/OwnerDetails/OwnerDetail"));
// const PaymentOption = lazy(() => import("../../../components/AccountSettings/PaymentOptions/PaymentOption"));
// const GeneralSettings = lazy(() => import("../../../components/AccountSettings/GeneralSettings/GeneralSettings"));
// const NotificationSettings = lazy(() => import("../../../components/AccountSettings/Notification/Notification"));
// const SecuritySettings = lazy(() => import("../../../components/AccountSettings/Security/Security"));
// const Profiles = lazy(() => import("../../../components/AccountSettings/Profiles/Profiles"));
// const ClientPayment = lazy(() => import("../../../components/AccountSettings/ClientPayment/ClientPayment"));
// const Integrations = lazy(() => import("../../../components/AccountSettings/Integrations/Integrations"));
// const InviteHistory = lazy(() => import("../../user/inviteHistory.jsx"));



// // Tabs configuration for centralized management
// const tabsConfig = [
//   {
//     index: 0,
//     labelKey: "Company_Profile",
//     component: (id) => <OwnerDetails id={id} />,
//     className: "company-profile",
//   },
//   {
//     index: 1,
//     labelKey: "Bank Accounts",
//     component: (id, typeOfAccount) =>
//       typeOfAccount === "Operational Accounts" ? <PaymentOption /> : <ClientPayment />,
//     className: "payment-option",
//     condition: (user) => user?.userType === 1 || user?.userType === 2,
//   },
//   {
//     index: 2,
//     labelKey: "Profiles",
//     component: (id) => <Profiles id={id} />,
//     className: "payment-option",
//   },
//   {
//     index: 4,
//     labelKey: "Subscription",
//     component: () => <div>Subscription content coming soon</div>,
//     className: "subscription",
//     condition: () => window.location.hostname !== "wx-agency.talenton.app",
//     disabled: true,
//   },
//   {
//     index: 5,
//     labelKey: "Security",
//     component: (id) => <SecuritySettings id={id} />,
//     className: "security-setting-option",
//   },
//   {
//     index: 6,
//     labelKey: "General_Settings",
//     component: (id) => <GeneralSettings id={id} />,
//     className: "general-setting-option",
//   },
//   {
//     index: 7,
//     labelKey: "Notifications",
//     component: (id) => <NotificationSettings id={id} />,
//     className: "notification-option",
//   },
//   {
//     index: 8,
//     labelKey: "Integrations",
//     component: (id) => <Integrations id={id} />,
//     className: "general-setting-option",
//   },
//   {
//     index: 9,
//     labelKey: "Invite History",
//     component: () => <InviteHistory />,
//     className: "general-setting-option",
//   },
// ];

// // Error Boundary Component
// class ErrorBoundary extends React.Component {
//   state = { hasError: false };

//   static getDerivedStateFromError() {
//     return { hasError: true };
//   }

//   render() {
//     if (this.state.hasError) {
//       return (
//         <div className="error-message" role="alert">
//           Error: Something went wrong
//         </div>
//       );
//     }
//     return this.props.children;
//   }
// }

// function AccountSettings() {
//   const dispatch = useDispatch();
//   const [activeTab, setActiveTab] = useState(() => {
//     const storedTab = localStorage.getItem("activeTab");
//     return storedTab ? Number(storedTab) : 0;
//   });
//   const { user } = useSelector((state) => state.auth || {});
//   const { appSettings } = useSelector((state) => state.appSettings || {});
//   const { typeOfAccount } = useSelector((state) => state.accountDetails || {});

//   const id = user?._id;

//   useEffect(() => {
//     dispatch(setHeaderText("Account Settings"));
//   }, [dispatch]);

//   const handleTabClick = (index) => {
//     setActiveTab(index);
//     localStorage.setItem("activeTab", String(index));
//   };

//   const handleKeyDown = (e, index) => {
//     if (e.key === "Enter" || e.key === " ") {
//       e.preventDefault();
//       handleTabClick(index);
//     }
//   };

//   // Fallback UI for missing data
//   if (!user || !id || typeof typeOfAccount === "undefined") {
//     return (
//       <section className="account-settings" aria-label="Account Settings">
//         <div className="error-message" role="alert">
//           Error: User or account data not available
//         </div>
//       </section>
//     );
//   }

//   return (
//     <ErrorBoundary>
//       <section className="account-settings" aria-label="Account Settings">
//         <div className="tab-outer-tab-account">
//           <ul className="tabs" role="tablist">
//             {tabsConfig.map(
//               ({ index, labelKey, condition, disabled }) =>
//                 (!condition || condition(user)) && (
//                   <li
//                     key={index}
//                     role="tab"
//                     aria-selected={activeTab === index}
//                     aria-controls={`tabpanel-${index}`}
//                     id={`tab-${index}`}
//                     className={activeTab === index ? "active-tab" : ""}
//                     style={disabled ? { pointerEvents: "none", opacity: 0.6 } : {}}
//                     onClick={() => !disabled && handleTabClick(index)}
//                     onKeyDown={(e) => !disabled && handleKeyDown(e, index)}
//                     tabIndex={0}
//                     aria-disabled={disabled ? "true" : "false"}
//                   >
//                     {global.config.locate?.(appSettings?.language, labelKey) || labelKey}
//                   </li>
//                 )
//             )}
//           </ul>

//           <div className="tabs-content account-settings-tab">
//             <Suspense fallback={<div></div>}>
//               {tabsConfig.map(
//                 ({ index, component, className, condition }) =>
//                   (!condition || condition(user)) && (
//                     <div
//                       key={index}
//                       id={`tabpanel-${index}`}
//                       role="tabpanel"
//                       className={className}
//                       style={{ display: activeTab === index ? "block" : "none" }}
//                       aria-labelledby={`tab-${index}`}
//                     >
//                       {component(id, typeOfAccount)}
//                     </div>
//                   )
//               )}
//             </Suspense>
//           </div>
//         </div>
//       </section>
//     </ErrorBoundary>
//   );
// }

// export default AccountSettings;

import "./accountSetting.css";
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import OwnerDetails from '../../../components/OwnerDetails/OwnerDetail';
import { setHeaderText } from "../../../features/headerText/headerTextSlice";
import PaymentOption from "../../../components/AccountSettings/PaymentOptions/PaymentOption";
import GeneralSettings from "../../../components/AccountSettings/GeneralSettings/GeneralSettings";
import NotificationSettings from "../../../components/AccountSettings/Notification/Notification";
import SecuritySettings from "../../../components/AccountSettings/Security/Security";

function AccountSettings() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const user = useSelector(
    (state) => state.auth.user
  );
  const { appSettings } = useSelector((state) => state.appSettings);

  const id = user._id;
  const handleTabClick = (index) => {
    setActiveTab(index);
    localStorage.setItem('activeTab', String(index));
  };

  useEffect(() => {
    const storedActiveTab = localStorage.getItem('activeTab');
    if (storedActiveTab) {
      setActiveTab(Number(storedActiveTab));
    }
    dispatch(setHeaderText("Account Settings"));
  }, [id, dispatch]);

  return (
    <div>

      <div className='tab-outer-tab-account'>
        <ul className="tabs">
          <li
            className={activeTab === 0 ? 'active-tab' : ''}
            onClick={() => handleTabClick(0)}
          >
            {global.config.locate(appSettings && appSettings.language, 'Company_Profile')}
          </li>

          {(user.userType === 1 || user.userType === 2) &&
            (<li
              className={activeTab === 1 ? 'active-tab' : ''}
              onClick={() => handleTabClick(1)}
            >
              Bank Accounts
            </li>)}

          <li
            className={activeTab === 4 ? 'active-tab' : ''}
            style={{ pointerEvents: "none", opacity: 0.6 }}
          >
            {global.config.locate(appSettings && appSettings.language, 'Subscription')}
          </li>
          <li
            className={activeTab === 5 ? 'active-tab' : ''}
            onClick={() => handleTabClick(5)}
          >
            {global.config.locate(appSettings && appSettings.language, 'Security')}
          </li>
          <li
            className={activeTab === 6 ? 'active-tab' : ''}
            onClick={() => handleTabClick(6)}
          >
            {global.config.locate(appSettings && appSettings.language, 'General_Settings')}
          </li>
          <li
            className={activeTab === 7 ? 'active-tab' : ''}
            onClick={() => handleTabClick(7)}
          >
            {global.config.locate(appSettings && appSettings.language, 'Notifications')}
          </li>
        </ul>

        <div className="tabs-content account-settings-tab">
          <div className='company-profile' style={{ display: activeTab === 0 ? 'block' : 'none' }}>
            <OwnerDetails id={id} />
          </div>
          <div className='payment-option' style={{ display: activeTab === 1 ? 'block' : 'none' }}>
            <PaymentOption id={id} />
          </div>
          <div style={{ display: activeTab === 4 ? 'block' : 'none' }}>
            Content of third tab
          </div>
          <div className='security-setting-option' style={{ display: activeTab === 5 ? 'block' : 'none' }}>
            <SecuritySettings id={id} />
          </div>
          <div className='general-setting-option' style={{ display: activeTab === 6 ? 'block' : 'none' }}>
            <GeneralSettings id={id} />
          </div>
          <div className='notification-option' style={{ display: activeTab === 7 ? 'block' : 'none' }}>
            <NotificationSettings id={id} />
          </div>
        </div>
      </div>
    </div >
  );
}

export default AccountSettings;
